module.exports = __webpack_public_path__ + "img/icon-critical.671a0a54.svg";